var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isAdmin)?_c('BaseActionBar',{attrs:{"items":_vm.actions}}):_vm._e(),_c('UserListTable',{attrs:{"is-loading":_vm.isLoading,"items":_vm.tableData,"pagination":_vm.pagination}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }